import React from 'react';
import protoaiData from '../data/protoai-data.json';

// protoAI Components
import PageHero from './components-protoai/PageHero';

// Extended Appiya Component
import AboutExtended from './components-about/AboutExtended';

const AboutPage = () => {
  return (
    <div>
      {/* ページヘッダー */}
      <PageHero
        title="会社情報"
        subtitle="私たちの使命は、「時間」という最大の制約から、日本のイノベーションを解放すること。"
        breadcrumb="会社情報"
      />

      {/* 会社概要 - Appiyaコンポーネント使用 */}
      <AboutExtended data={protoaiData.about} />
    </div>
  );
};

export default AboutPage;